<template>
  <button
    class="btn-drop"
    :class="{'btn-drop--active': isDropActive}"
    @click="onClick"
    type="button"
  >
    {{text}}
    <svg
      class="dropdown-icon btn-drop__icon"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2"/>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'ButtonDrop',
  props: {
    text: {
      type: String,
      default: 'Развернуть'
    },
    isDropActive: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick () {
      this.$emit('update:is-drop-active', !this.isDropActive)
    }
  }
}
</script>
